<div
  class="type-col"
  [ngClass]="getTypeClass()">
  <mg-icon class="flag">flag-icon</mg-icon>
  <mg-icon class="polls">polls-o</mg-icon>
  <mg-icon class="checkin">checkin-8</mg-icon>
  <div class="type-icon"></div>
</div>
